import LocationOverviewEmployeesDirectoryAddEmployeeNewRoute from 'garaje/pods/location-overview/employees/directory/add-employee/new/route';

export default class EmployeesDirectoryAddEmployeeNewRoute extends LocationOverviewEmployeesDirectoryAddEmployeeNewRoute {
  controllerName = 'location-overview/employees/directory/add-employee/new';
  templateName = 'location-overview/employees/directory/add-employee/new';
}
